import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/my-awesome-ds-2/my-awesome-ds-2/node_modules/@bridgetool/gatsby-theme-dev/src/components/ThemeComponents/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This design system website is made with `}<a parentName="p" {...{
        "href": "http://bridgetool.io/"
      }}>{`Bridge`}</a>{`, the tool which bridges the
gap between design and development making it possible to build your brand and design system together!`}</p>
    <h3>{`Living documentation`}</h3>
    <p>{`With Bridge, you can easily create a living design system documentation together as a team. Design guidelines, visual language, style guides, pattern libraries, and your processes, all get represented.`}</p>
    <h3>{`Friendly environment`}</h3>
    <p>{`Bridge offers a friendly environment and familiar interface for designers, developers, and other specialists. Edit your documentation via our interface with great UX or directly in its code source.`}</p>
    <h3>{`Integration with tools`}</h3>
    <p>{`Integration with the most popular design and development tools ensures a seamless documenting process and no double work.`}</p>
    <h3>{`Full control over sources`}</h3>
    <p>{`Bridge helps you edit and maintain, but you still own the source code, it is hosted in your repository, which you have full control.`}</p>
    <h3>{`No boring routines`}</h3>
    <p>{`We take care of all necessary routine and automation, working by default or custom-made via a human-friendly interface.`}</p>
    <h3>{`Rich features for free`}</h3>
    <p>{`Bridge keeps the most desired features free. We design the solutions so that you can stay on the free plan as long as possible.`}</p>
    <h3>{`Scale with your needs`}</h3>
    <p>{`Choosing Bridge means you only need to pay for the selected features. Drop off anything you don't need to fit your budget.`}</p>
    <h3><a parentName="h3" {...{
        "href": "http://bridgetool.io/"
      }}>{`Build your own design system documentation website with Bridge`}</a></h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      